import { AppState } from "../../../redux-configuration/AppState";

export const addMunicipalServiceLoadingSelector = (appState: AppState): boolean => appState.municipality.addService.loading
export const addMunicipalServiceErrorSelector = (appState: AppState): string | undefined => appState.municipality.addService.error
